import {getMethod, postMethod, putMethod, deleteMethod} from '~/api'

async function get(packageId, request) {
    return await getMethod(`/api/ownPackageContracts/${packageId}/availability`, request)
}

async function post(packageId, request) {
    return await postMethod(`/api/ownPackageContracts/${packageId}/availability`, request)
}

async function put(packageId, availabilityId, request) {
    return await putMethod(`/api/ownPackageContracts/${packageId}/availability/${availabilityId}`, request)
}

async function remove(packageId, availabilityId) {
    return await deleteMethod(`/api/ownPackageContracts/${packageId}/availability/${availabilityId}`)
}

export {get, post, put, remove}
